import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/auth';

/**
 * The old /dashboard route showed different content per persona — issue
 * #307's redirect table sends it to the persona-appropriate /portal/*
 * landing tab. Revised 2026-08-20 per direct product feedback: the
 * patient-link tab is the landing page for anyone with a doctorProfile
 * (plain doctor or admin+doctor), matching "Doctors" no longer being a
 * top-nav tab (portal-links.ts) — it's no longer the default thing either
 * admin persona sees. An admin with no doctorProfile has no patient-link
 * tab at all, so lands on Clinic Details, their sole remaining top tab.
 */
export function DashboardRedirect() {
  const { user } = useAuth();
  const hasDoctorProfile = !!user?.doctorProfile;

  return <Navigate to={hasDoctorProfile ? '/portal/link' : '/portal/clinic'} replace />;
}
